// src/shared/navigation/menu.ts
import type { AbilityKey } from '@/shared/auth';

export interface MenuItem {
  label: string;
  path:  string;
  ability?: AbilityKey; // DB-driven ability string
}

export const MENU: MenuItem[] = [
  // { label: 'Cash Register',    path: '/cash-register',   ability: 'CashRegister.Viewer' },
  // { label: 'Order',            path: '/order',           ability: 'Order.view' },
  // { label: 'Products',         path: '/stock',           ability: 'Products.view' },
  { label: 'Sales / Purchase', path: '/sales-purchase',  ability: 'system.services.manage' },
  // { label: 'TT-Lock',          path: '/ttlock',          ability: 'ttlock.room.superadmin' },
  // { label: 'Room',             path: '/ttlock/rooms',    ability: 'ttlock.view' },
  // { label: 'Media',            path: '/media',           ability: 'media.library.view' },
  { label: 'Developer',        path: '/developer',       ability: 'system.developer.view' },
  { label: 'Admin',            path: '/admin',           ability: 'system.admin.view' },
  { label: 'Devices',          path: '/devices',         ability: 'system.devices.iot.view' },
];
